// extracted by mini-css-extract-plugin
module.exports = {"StockAnalystsPage":"analysts_StockAnalystsPage__O5piN"};